<template>
  <a-popover v-if="guide" placement="rightTop" trigger="hover" :overlay-style="{ maxWidth: '520px' }">
    <template #content>
      <div class="gzh-field-help">
        <div class="gzh-field-help__desc">{{ guide.desc }}</div>
        <div class="gzh-field-help__path">
          <span class="gzh-field-help__path-label">位置</span>
          <span>{{ guide.path }}</span>
        </div>
        <img
          v-if="guide.img"
          :src="guide.img"
          :alt="guide.path"
          class="gzh-field-help__img"
        />
        <div v-if="guide.note" class="gzh-field-help__note">{{ guide.note }}</div>
        <a
          class="gzh-field-help__link"
          href="https://mp.weixin.qq.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          打开微信公众平台
          <link-outlined />
        </a>
      </div>
    </template>
    <question-circle-outlined class="gzh-field-help__icon" />
  </a-popover>
</template>

<script>
import { QuestionCircleOutlined, LinkOutlined } from '@ant-design/icons-vue';

// 각 필드별 위챗 콘솔 위치 안내(캡처 이미지는 public/gzh-guide/*.png).
// [보안] 캡처의 실제 Token/EncodingAESKey 값은 검게 마스킹된 안내용 이미지다.
const FIELD_GUIDES = {
  gzhName: {
    desc: '系统内部唯一标识，由运营方与제조사约定命名（如 thermage-china-dyh）。非微信提供字段，注册后不可修改。',
    path: '本系统内部约定（小写字母/数字/连字符）',
  },
  displayName: {
    desc: '列表中显示的公众号名称，可与微信公众号名称一致（如「舒美 订阅号」）。运营方自定义，非微信字段。',
    path: '自定义显示名称',
  },
  accountType: {
    desc: '公众号类型。微信公众平台「账号详情 → 类型」处显示为「订阅号」或「服务号」。服务号才能调用小程序关联等高级接口。',
    path: '微信公众平台 → 账号设置 → 账号详情 → 类型',
  },
  appId: {
    desc: '开发者ID(AppID)，账号开发识别码。配合 AppSecret 调用接口。',
    path: '微信公众平台 → 设置与开发 → 基本配置 → 账号开发信息 → 开发者ID(AppID)',
    img: '/gzh-guide/appdev.png',
  },
  appSecret: {
    desc: '开发者密码(AppSecret)。仅在「重置」后显示一次，请立即复制。切勿泄露。',
    path: '微信公众平台 → 设置与开发 → 基本配置 → 账号开发信息 → 开发者密码(AppSecret) → 重置',
    img: '/gzh-guide/appdev.png',
    note: '提示: AppSecret 页面默认不显示，需点击「重置」生成后复制。重置会使旧密码失效。',
  },
  token: {
    desc: '服务器配置的令牌(Token)，用于校验消息来源。须与本系统填写值完全一致。',
    path: '微信公众平台 → 设置与开发 → 基本配置 → 服务器配置 → 令牌(Token)',
    img: '/gzh-guide/serverconfig.png',
    note: '截图中的值已打码。请填写您在微信服务器配置中设置的实际 Token。',
  },
  encodingAesKey: {
    desc: '消息加解密密钥(EncodingAESKey)，43位。安全模式下消息加解密必需，须与本系统填写值一致。',
    path: '微信公众平台 → 设置与开发 → 基本配置 → 服务器配置 → 消息加解密密钥(EncodingAESKey)',
    img: '/gzh-guide/serverconfig.png',
    note: '截图中的值已打码。可在服务器配置中点击「随机生成」后复制填入两处（微信 + 本系统）。',
  },
  gzhUserId: {
    desc: '公众号原始ID(gh_ 开头)。可选项 — 用于消息回调的 ToUserName 匹配与日志。新版微信界面可能不直接展示，留空不影响接入。',
    path: '微信公众平台 → 账号设置 → 账号详情（部分账号显示）',
    note: '可选字段。若界面未显示，可留空。',
  },
};

export default {
  name: 'GzhFieldHelp',
  components: { QuestionCircleOutlined, LinkOutlined },
  props: {
    field: { type: String, required: true },
  },
  computed: {
    guide() {
      return FIELD_GUIDES[this.field] || null;
    },
  },
};
</script>

<style lang="scss" scoped>
.gzh-field-help__icon {
  margin-left: 4px;
  color: #999;
  cursor: help;
  &:hover { color: #1677ff; }
}
.gzh-field-help {
  max-width: 480px;
  &__desc {
    font-size: 13px;
    line-height: 1.6;
    color: #333;
    margin-bottom: 8px;
  }
  &__path {
    display: flex;
    gap: 6px;
    font-size: 12px;
    color: #666;
    margin-bottom: 8px;
    line-height: 1.5;
  }
  &__path-label {
    flex: 0 0 auto;
    background: #f0f0f0;
    border-radius: 3px;
    padding: 0 6px;
    color: #888;
  }
  &__img {
    display: block;
    width: 100%;
    border: 1px solid #eee;
    border-radius: 4px;
    margin-bottom: 8px;
  }
  &__note {
    font-size: 12px;
    color: #d46b08;
    background: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 4px;
    padding: 4px 8px;
    margin-bottom: 8px;
    line-height: 1.5;
  }
  &__link {
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
}
</style>
